import Vue from 'vue'
//常用状态管理
export const states = {
  system: {
    //缴费类型
    payTypes: [{ value: '需要', code: 1 }, { value: '不需要', code: 2 }],
    //性别
    genderTypes: [{ value: '男', code: 1 }, { value: '女', code: 0 },],
    //系统类别
    systemTypes: [{ value: '前台', code: 1 }, { value: '后台', code: 2 }],
    //审核状态1
    auditStatus: [{ value: '未审核', code: 0 }, { value: '审核通过', code: 1 }, { value: '审核拒绝', code: 2 }],
    //审核状态2
    auditStatusTwo: [{ value: '未审核', code: 0 }, { value: '审核通过', code: 1 }, { value: '审核拒绝', code: 2 }, { value: '保存', code: 3 }],
    //是否
    orTypes: [{ value: '是', code: 1 }, { value: '否', code: 0 }],
    //公告类型
    noticeTypes: [{ value: '交易公告', code: 1 }, { value: '消息公告', code: 2 }],
    //短信状态
    msgStatus: [{ value: '发送失败', code: 0 }, { value: '发送成功', code: 1 }, { value: '已作废', code: 2 }],
    //站内信状态
    znMsgStatus: [{ value: '未读', code: 0 }, { value: '已读', code: 1 }, { value: '删除', code: 2 }],
    // 发布端
    publishTypes: [{ value: 'PC', code: '1'}, { value: '移动端', code: '2' }, { value: '小程序', code: '3' }],
  },
  bid: {
    //买卖方向
    transTypes: [{ value: '买', code: 1 }, { value: '卖', code: 2 }],
    //会费类型
    duesTypes: [{ value: '新入会', code: 1 }, { value: '转出', code: 2 }, { value: '续会', code: 3 }, { value: '退会', code: 4 }, { value: '转入', code: 5 }],
    //会费状态
    duesStatusTypes: [{ value: '正常', code: 0 }, { value: '异常', code: 1 }],
    //商品状态
    spTypes: [{ value: '全部成交', code: 1 }, { value: '未成交', code: 2 }, { value: '部分成交', code: 3 }, { value: '已流拍', code: 4 }, { value: '交易中', code: 5 }],
    //保证金收取方式
    bondTypes: [{ value: '百分比', code: 1 }, { value: '绝对值', code: 2 }],
    //手续费收取方式
    sxfTypes: [{ value: '百分比', code: 1 }, { value: '绝对值', code: 2 }],
    //开市状态
    xtTypes: [{ value: '未开市', code: 0 }, { value: '已开市', code: 1 }, { value: '强制开市', code: 2 }, { value: '闭市', code: 3 }, { value: '强制闭市', code: 4 }, { value: '节间休息', code: 5 }, { value: '待闭市', code: 6 }, { value: '待开市', code: 7 }],
    //合同状态
    htTypes: [{ value: '待处理', code: 1 }, { value: '部分履约', code: 2 }, { value: '全部履约', code: 3 }, { value: '买方违约', code: 4 }, { value: '卖方违约', code: 5 }, { value: '双方违约', code: 6 }, { value: '全部取消', code: 7 }, { value: '部分取消', code: 8 }],
    //交易板块操作类型
    jyOperTypes: [{ value: '启动系统', code: 1 }, { value: '手动开市', code: 2 }, { value: '强制开市', code: 3 }, { value: '禁止下单', code: 4 }, { value: '暂停交易', code: 5 }, { value: '恢复交易', code: 6 }, { value: '闭市成交', code: 7 }, { value: '闭市', code: 8 }, { value: '闭市处理', code: 9 }, { value: '恢复下单', code: 10 }],
    //交易商状态
    freeTypes: [{ value: '正常', code: 1 }, { value: '冻结', code: 0 }],
    //连续下单权限
    orderQxsTypes: [{ value: '允许', code: 1 }, { value: '不允许', code: 0 }],
    //挂单权限
    registerQxsTypes: [{ value: '有挂单权限', code: 1 }, { value: '无挂单权限', code: 0 }],
    //是否开启强制结束(交易节设置)
    forceEndTypes: [{ value: '开启', code: 1 }, { value: '关闭', code: 0 }],
    //当前商品状态
    currSpTypes: [{ value: '禁止下单', code: 0 }, { value: '正常委托', code: 1 }, { value: '全部成交', code: 2 }, { value: '部分成交', code: 3 }, { value: '已流拍', code: 4 }],
    //历史报价查询状态
    offerTypes: [{ value: '全部成交', code: 1 }, { value: '部分成交', code: 2 }, { value: '全部撤单', code: 3 },],
    //场次报价查询
    cjTypes: [{ value: '已委托', code: 1 }, { value: '部分撤单', code: 2 }, { value: '全部撤单', code: 3 }]
  },
  fund: {
    //冻结状态
    stateTypes: [{ value: '未冻结', code: 1 }, { value: '冻结', code: 0 }],
  },
  listed: {
    //是否
    orTypes: [{ value: '是', code: 1 }, { value: '否', code: 0 }],
    //会员搜索类型
    hySearchTypes: [{ value: '会员名称', code: 1 }, { value: '会员代码', code: 2 }],
    //收费方式
    sfTypes: [{ value: '成交量（元/吨）', code: 1 }, { value: '成交额（%）', code: 2 }],
    //条款模板组合
    tkMbTypes: [{ value: '文字内容', code: 1 }, { value: '输入框', code: 2 }, { value: '下拉列表', code: 3 }],
    //合同状态
    htStatusTypes: [
      { code: '0', value: '作废' },
      { code: '10', value: '待卖方编辑合同' },
      { code: '20', value: '待卖方确认合同' },
      { code: '30', value: '待买方确认合同' },
      { code: '40', value: '待买方支付货款' },
      { code: '50', value: '提货中（待卖方生成提单）' },
      { code: '70', value: '已生成提单' },
      { code: '80', value: '待买方到货确认' },
      { code: '90', value: '验货确认' },
      { code: '100', value: '待开票' },
      { code: '110', value: '待到票' },
      { code: '120', value: '已完成' },
      { code: '200', value: '违约处理中' },
      { code: '210', value: '违约终止' },
    ],
    //提单状态
    tdTypes: [
      { code: '70', value: '待实提维护' },
      { code: '80', value: '待买方到货确认' },
      { code: '90', value: '已验货确认待结算' },
      { code: '210', value: '违约终止' },
    ],
    //发票转态
    fpTypes: [{ code: '1', value: '已开票未验票' }, { code: '2', value: '已验票' }],
    //发货状态
    fhCodes: [
      { code: '75', value: '待发货确认' },
      { code: '80', value: '待买方到货确认' },
      { code: '90', value: '已验货确认待结算' }
    ],
  },
  purchase: {
    //竞价申请审核
    bidVerifyTypes: [{ value: '全部', code: 0 }, { value: '待审核', code: 20 }, { value: '已驳回', code: 8 }],
    //竞拍管理-场次状态
    fieldTypes2: [{ value: '已中止', code: 1 }, { value: '已审核', code: 30 }, { value: '待竞拍', code: 31 }, { value: '申请中止', code: 35 }, { value: '竞拍中', code: 40 }, { value: '已结束', code: 50 }, { value: '已成交', code: 60 }, { value: '已流标', code: 61 }],
  },
  auction: {
    //是否
    orTypes: [{ value: '是', code: 1 }, { value: '否', code: 0 }],
    //竞拍申请审核
    bidVerifyTypes: [{ value: '全部', code: 0 }, { value: '待审核', code: 20 }, { value: '已驳回', code: 8 }, { value: '已通过', code: 30 }],
    //手续费收取方式
    sxfCollectTypes: [{ value: '按次收取', code: 0 }, { value: '吨位收取', code: 1 }, { value: '起拍总价收取', code: 2 }],
    //平台服务费收取方式
    ptFwfCollectTypes: [{ value: '按成交总价取', code: 3 }, { value: '按固定金额收取', code: 4 }],
    ptFwfCollectTypes1: [{ value: '按成交总价取', code: 3 }, { value: '按固定金额收取', code: 4 }, { value: '按数量收取', code: 5 }],// ,

    //竞拍委托-场次状态
    fieldTypes: [{ value: '已作废', code: 0 }, { value: '已中止', code: 1 }, { value: '已审核', code: 30 }, { value: '待竞拍', code: 31 }, { value: '申请中止', code: 35 }, { value: '竞拍中', code: 40 }, { value: '已结束', code: 50 }, { value: '已成交', code: 60 }, { value: '已流标', code: 61 }],
    //竞拍管理-场次状态
    fieldTypes2: [{ value: '已中止', code: 1 }, { value: '已审核', code: 30 }, { value: '待竞拍', code: 31 }, { value: '申请中止', code: 35 }, { value: '竞拍中', code: 40 }, { value: '已结束', code: 50 }, { value: '已成交', code: 60 }, { value: '已流标', code: 61 }],
    fieldTypes2_new: [{ value: '已中止', code: 1 }, { value: '已审核', code: 30 }, { value: '待竞拍', code: 31 }, { value: '申请中止', code: 35 }, { value: '竞拍中', code: 40 }, { value: '评标中', code: 50 }, { value: '已成交', code: 60 }, { value: '已流标', code: 61 }],
    //询价管理-场次状态
    fieldTypes3: [{ value: '已中止', code: 1 }, { value: '审核中', code: 20 }, { value: '待提交', code: 10 }, { value: '询价中', code: 40 }, { value: '已结束', code: 50 }, { value: '已完成', code: 60 }, { value: '已流标', code: 61 }],
    // 保证金管理状态
    bzjType: [{ value: '无需交纳', code: -1 }, { value: '未交纳', code: 0 }, { value: '已交纳', code: 1 }, { value: '未申请退', code: 2 }, { value: '已申请退', code: 3 }, { value: '卖方暂缓退款', code: 4 }, { value: '已拒绝 ', code: 5 }, { value: '申诉中', code: 6 }, { value: '平台已退', code: 7 }],
    // 询价-保证金管理状态
    bzjType1: [{ value: '无需交纳', code: -1 }, { value: '未交纳', code: 0 }, { value: '已交纳', code: 1 }, { value: '未申请退', code: 2 }, { value: '已申请退', code: 3 }, { value: '买方暂缓退款', code: 4 }, { value: '已拒绝 ', code: 5 }, { value: '申诉中', code: 6 }, { value: '平台已退', code: 7 }],
    feeType: [{ value: '未交纳', code: 1 }, { value: '无须交纳', code: 2 }, { value: '已交纳', code: 3 }, { value: '未确认', code: 4 }],
    serviceType: [{ value: '保证金扣除', code: 1 }, { value: '线下转账', code: 2 }, { value: '钱包扣除', code: 3 }],
    // 竞拍管理-成交方式
    dealTypes: [{ value: '自动成交', code: 1 }, { value: '审批成交', code: 2 }],
  },
  quote: {
    //是否
    orTypes: [{ value: '是', code: 1 }, { value: '否', code: 0 }],
    checkType: [{ value: '待巡检', code: 0 }, { value: '已巡检', code: 1 }],
    //洽谈转态
    qtTypes: [
      { code: '0', value: '未洽谈' },
      { code: '1', value: '待卖方响应' },
      { code: '2', value: '待买方响应' },
      { code: '3', value: '同意报价' },
      { code: '4', value: '拒绝报价' },
      { code: '5', value: '洽谈失效' }
    ],
  }
}

//搜索条件类型管理
export const searchOptions = {
  system: {
    //变更类型(0:银行变更,1：资质变更,2：发票变更)
    optType: { type0: 0, type1: 1, type2: 2 },
  }
}

//文件类型管理
export const uploadTypes = {
  system: {
    /**菜单目录 */
    //子系统图标
    SYS_TYPE1: "SYS001",
    /**基本设置 */
    //分类图标
    SYS_TYPE2: "SYS002",
    /**会员管理 */
    //税务登记证
    SYS_TYPE3: "SYS003",
    //营业执照
    SYS_TYPE4: "SYS004",
    //组织机构代码证
    SYS_TYPE5: "SYS005",
    //法定代表人证明
    SYS_TYPE6: "SYS006",
    //法人授权委托书
    SYS_TYPE7: "SYS007",
    //银行开户许可证
    SYS_TYPE8: "SYS008",
    //一般纳税人资格
    SYS_TYPE9: "SYS009",
    //资质图片
    SYS_TYPE10: "SYS010",
    //开票及邮寄信息
    SYS_TYPE11: "SYS011",
    //电子印章
    SYS_TYPE12: "SYS012",
    //统一社会信用代码证
    SYS_TYPE13: "SYS013",
    //系统LOGO
    SYS_TYPE14: "SYS014",
    //系统图标
    SYS_TYPE15: "SYS015",
  },
  bid: {
    //品名图片
    BTS_TYPE1: "BTS001",
  },
  fund: {
    //银行logo
    FUND_TYPE1: "FUND001"
  }
}

//文件上传类型
export const upFileTypes = {
  img: 'image/png,image/jpg,image/jpeg',
  file: '.docx,.pdf,.ppt,.xls,.xlsx,.pptx,.doc',
  allfile: 'image/png,image/jpg,image/jpeg,.docx,.pdf,.ppt,.xls,.xlsx,.pptx,.doc'
}
Vue.prototype._STATES = states
Vue.prototype._STYPES = searchOptions
Vue.prototype._UPLOADS = uploadTypes
Vue.prototype._UPTYPES = upFileTypes





// WEBPACK FOOTER //
// ./src/server/common-type.js